import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PTs from 'prop-types';
import React from 'react';

import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import s from './Question.scss';

class Question extends React.Component {
  static propTypes = {
    answer: PTs.node,
    question: PTs.node.isRequired,
  };

  static defaultProps = {
    answer: '',
  };

  state = {
    displayAnswer: false,
  };

  toggleState = () => {
    this.setState(state => ({
      displayAnswer: !state.displayAnswer,
    }));
  };

  render() {
    const { answer, question } = this.props;
    const { displayAnswer } = this.state;
    return (
      <div>
        <button className={s.question} onClick={this.toggleState} type="button">
          {question}
          <FontAwesomeIcon icon={faAngleDown} />
        </button>
        {displayAnswer && <div className={s.answer}>{answer}</div>}
      </div>
    );
  }
}

export default withStyles(s)(Question);
